var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectFavoriteAppsMenu',{attrs:{"nudge-right":-350,"nudge-bottom":48,"hidePrevious":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('AnemicButton',{staticClass:"add-button px-7",attrs:{"tile":""}},[_vm._v("Add apps")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }